/*
    This pipe overrides the default currency pipe from angular,
    this can be removed when angular supports currency defaults
    https://github.com//issues/25461
*/

import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'environments/environment';

@Pipe({
  name: 'customCurrency'
})
export class DefaultCurrencyPipe extends CurrencyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {
    super(environment.locale);
  }

  transform(value: any, currency: string, symbol?: string): any {
    if (environment.region === 'nl') {
      return this.currencyPipe.transform(
        value,
        currency = 'EUR',
        symbol = '€'
      );
    }
    if (environment.region === 'us') {
      return this.currencyPipe.transform(
        value,
        currency = 'USD',
        symbol = '$'
      );
    }
    return this.currencyPipe.transform(value);
  }
}
